import React from 'react'
import { Redirect, NavLink } from 'react-router-dom'
import {
  Segment,
  Table,
  Grid,
  Dropdown,
  Header,
  Icon,
  Button,
  Loader,
} from 'semantic-ui-react'

import find from 'lodash/find'

import { resolveGradingScheme } from '../../utils/gradingScheme'

import './Classes.css'

const _ = {
  find: find
}

const ClassesPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'levelHead') {
    const {
      column, direction, sections,
      schoolYearId, sectionId, sectionSubjects
    } = props;
    if (!props.currentSchoolYear && sections) return null;
    let optionsSchoolYears;
    if (props.schoolYears) {
      optionsSchoolYears = props.schoolYears.map((schoolYear,index) => {
        return (
            { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
        )
      })
    }

    // How many periods this school year has, and what they are called. Every
    // status column and every link below is built from this, so a three-term
    // year can never show a fourth column or link to ?quarter=4.
    const selectedSchoolYear = _.find(props.schoolYears || [], {
      schoolYearId: schoolYearId,
    });
    const currentSection = _.find(sections || [], { sectionId: sectionId });
    const scheme = resolveGradingScheme(
      selectedSchoolYear,
      currentSection ? currentSection.gradeLevel : null,
      { levelType: currentSection ? currentSection.levelType : '' }
    );
    const periods = scheme.periods;
    // usesPace, not mode: Kinder is descriptive but has no PACE form, and from
    // SY 2027-2028 so is Grade 2. Every other consumer of the PACE link asks
    // this question the same way.
    const isDescriptive = scheme.usesPace;

    let optionsSections;
    if (sections) {
      optionsSections = sections.map((section,index) => {
        const displayText = section.gradeLevel + ' - ' + section.name;
        return (
            { key: section.sectionId, value: section.sectionId, text: displayText }
        )
      })
    }


    // One helper for every status cell: find the workflow row for this period
    // and type, and render it as a link into the right entry page.
    const statusCell = (detail, to, key) => (
      <Table.Cell textAlign='center' key={key}>
        <NavLink to={to}>
          {detail.status === 'Approved'
            ? <Icon name='check circle' color='green'/>
            : detail.status}
        </NavLink>
      </Table.Cell>
    );

    const NOT_AVAILABLE = { status: 'Not Available' };
    const detailFor = (details, type, period) =>
      _.find(details || [], { quarter: period.index, type: type }) || NOT_AVAILABLE;

    let classSectionBody;

    const subjectsTable = sectionSubjects.map((sectionSubject, key )=> {
      if (!sectionSubject.details) {
        return null; // Skip this item if details are missing
      }

      const section = _.find(sections, { sectionId: sectionId });
      if (!section || !section.details) {
        return null; // Skip this item if section or details are missing
      }

      classSectionBody = (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell textAlign='center'>
            {section.gradeLevel} - {section.name}
          </Table.Cell>
          {periods.map((period) => [
            statusCell(
              detailFor(section.details, 'attendance', period),
              `/attendances/${schoolYearId}/${sectionId}?quarter=${period.index}`,
              `att-${period.index}`
            ),
            statusCell(
              detailFor(section.details, 'conduct', period),
              `/classconducts/${sectionId}?quarter=${period.index}`,
              `con-${period.index}`
            ),
            statusCell(
              detailFor(section.details, 'remark', period),
              `/remarks/${sectionId}?quarter=${period.index}`,
              `rem-${period.index}`
            ),
          ])}
        </Table.Row>
      )

      return (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell>{sectionSubject.subject.name}</Table.Cell>
          {periods.map((period) => [
            <Table.Cell textAlign='center' key={`grade-${period.index}`}>
              <NavLink to={`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${period.index}`}>
                {detailFor(sectionSubject.details, 'grade', period).status === 'Approved'
                  ? <Icon name='check circle' color='green'/>
                  : detailFor(sectionSubject.details, 'grade', period).status}
              </NavLink>
              {/* Grade 1 records per-competency ratings on the PACE form as
                  well as the summary letter that prints on the card. */}
              {isDescriptive && (
                <NavLink
                  to={`/pace/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${period.index}`}
                  title='Open the PACE form'
                  className='classes-pace-link'
                >
                  <Icon name='list alternate outline' />
                </NavLink>
              )}
            </Table.Cell>,
            statusCell(
              detailFor(sectionSubject.details, 'conduct', period),
              `/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${period.index}`,
              `conduct-${period.index}`
            ),
          ])}
        </Table.Row>
      );
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            rowSpan='3'
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => props.handleSort('name')}
          >
            Subjects
          </Table.HeaderCell>
          <Table.HeaderCell colSpan={String(periods.length * 2)} textAlign='center'>Status</Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          {periods.map((period, i) => (
            <Table.HeaderCell
              key={period.index}
              textAlign='center'
              className={i === 0 ? 'section-subject-first' : undefined}
              colSpan='2'
            >
              {period.label}
            </Table.HeaderCell>
          ))}
        </Table.Row>
        <Table.Row>
          {periods.map((period, i) => [
            <Table.HeaderCell
              key={`acad-${period.index}`}
              textAlign='center'
              className={i === 0 ? 'section-subject-first' : undefined}
            >
              Academic
            </Table.HeaderCell>,
            <Table.HeaderCell key={`cond-${period.index}`} textAlign='center'>
              Conduct
            </Table.HeaderCell>,
          ])}
        </Table.Row>
      </Table.Header>
    )

    return (
      <div>
        <Segment>
          {
            props.loaded ?
            <div>
            <Grid centered columns={5}>
              <Grid.Column>
                <Dropdown
                  selection
                  name='schoolYearId'
                  options={optionsSchoolYears}
                  onChange={props.handleChange}
                  value={schoolYearId}
                />
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  selection
                  search
                  name='sectionId'
                  placeholder='Section'
                  options={optionsSections}
                  onChange={props.handleChange}
                  value={sectionId}
                />
              </Grid.Column>
            </Grid>

            {
              sectionSubjects.length === 0 ?
              <Segment placeholder>
                <Header icon>
                  <Icon name='database' />
                  Select a section or populate the section with subjects.
                </Header>
                <Button primary>Section Page</Button>
              </Segment> :
              <div className='classes-div-table'>
                <Table celled>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell
                        rowSpan='3'
                        textAlign='center'
                        sorted={column === 'name' ? direction : null}
                        onClick={() => props.handleSort('name')}
                      >
                        Class
                      </Table.HeaderCell>
                      <Table.HeaderCell colSpan={String(periods.length * 3)} textAlign='center'>Status</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                      {periods.map((period, i) => (
                        <Table.HeaderCell
                          key={period.index}
                          textAlign='center'
                          className={i === 0 ? 'section-subject-first' : undefined}
                          colSpan='3'
                        >
                          {period.label}
                        </Table.HeaderCell>
                      ))}
                    </Table.Row>
                    <Table.Row>
                      {periods.map((period, i) => [
                        <Table.HeaderCell
                          key={`att-${period.index}`}
                          textAlign='center'
                          className={i === 0 ? 'section-subject-first' : undefined}
                        >
                          Attendance
                        </Table.HeaderCell>,
                        <Table.HeaderCell key={`con-${period.index}`} textAlign='center'>Conduct</Table.HeaderCell>,
                        <Table.HeaderCell key={`rem-${period.index}`} textAlign='center'>Remark</Table.HeaderCell>,
                      ])}
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {classSectionBody}
                  </Table.Body>
                </Table>

                <Table celled sortable striped compact size='small'>
                  {headers}

                  <Table.Body>{subjectsTable}</Table.Body>
                </Table>

              </div>
            }
          </div> :
          <Loader active inline='centered' />
          }


        </Segment>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default ClassesPV;
